/* eslint-disable */

/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdQRCodeProps } from './type';
const props: TdQRCodeProps = {
  /** 二维码背景颜色 */
  bgColor: {
    type: String,
    value: '',
  },
  /** 是否有边框 */
  borderless: {
    type: Boolean,
    value: false,
  },
  /** 二维码颜色 */
  color: {
    type: String,
    value: '',
  },
  /** 二维码中图片的地址 */
  icon: {
    type: String,
    value: '',
  },
  /** 二维码中图片的大小 */
  iconSize: {
    type: null,
    value: 40,
  },
  /** 二维码纠错等级 */
  level: {
    type: String,
    value: 'M',
  },
  /** 二维码大小 */
  size: {
    type: Number,
    value: 160,
  },
  /** 二维码状态 */
  status: {
    type: String,
    value: 'active',
  },
  /** 扫描后的文本 */
  value: {
    type: String,
    value: '',
  },
};

export default props;
